import BackgroundVideo from './BackgroundVideo';
import BackgroundImage from './BackgroundImage';
import BackgroundHoverVideo from './BackgroundHoverVideo';
import BackgroundHoverImage from './BackgroundHoverImage';
import TransitionVideo from './TransitionVideo';

class BackgroundManager {
	constructor(el) {
		this.breakpoint = window.matchMedia('(orientation: portrait)');

		this.videos = [];
		this.transitionInits = [];
		this.transitions = [];
		this.transitionIndex = 0;

		this.videoError = false;
	}

	checkForTransitionVideos() {
		return new Promise((resolve, reject) => {
			if (this.breakpoint.matches === false && !this.videoError) {
				// Desktop

				this.transitionVideos = document.querySelectorAll('[data-transition-video]');
				if (!this.transitionVideos) {
					resolve();
				}

				if (this.transitionVideos) {
					this.transitionVideos.forEach((elm) => {
						const transitionVideo = new TransitionVideo(elm);
						this.transitions.push(transitionVideo);
						this.transitionInits.push(transitionVideo.init());
					});
				}

				Promise.all(this.transitionInits)
					.then(() => {
						resolve();
					})
					.catch(() => {
						this.videoError = true;
						resolve();
					});
			} else {
				// Mobile
				resolve();
			}
		});
	}

	selectTransition() {
		return new Promise((resolve) => {
			if (this.breakpoint.matches === false && !this.videoError && this.transitions) {
				// Desktop
				this.transition = this.transitions[this.transitionIndex];
				if (!this.transition) {
					resolve();
				} else {
					Promise.all([this.transition.show(), this.minimalTransitionDuration()]).then(() => {
						resolve();
						this.transitionIndex = this.transitionIndex + 1;
						if (this.transitionIndex > this.transitions.length - 1) {
							this.transitionIndex = 0;
						}
					});
				}
			} else {
				// Mobile
				resolve();
			}
		});
	}

	minimalTransitionDuration() {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, 1200);
		});
	}

	endTransition() {
		return new Promise((resolve) => {
			if (this.breakpoint.matches === false && !this.videoError && this.transition) {
				// Desktop
				this.transition.hide().then(resolve());
			} else {
				// Mobile
				resolve();
			}
		});
	}

	checkForVideos(container) {
		return new Promise((resolve) => {
			if (this.videoError) {
				resolve();
				return;
			}
			if (this.breakpoint.matches === false) { // Desktop
				this.backgroundVideoDesktop = container.querySelector('[data-background-video-desktop]');
				this.backgroundImageDesktop = container.querySelector('[data-background-image-desktop]');
				if (this.backgroundVideoDesktop) {
					this.background = new BackgroundVideo(this.backgroundVideoDesktop, 'desktop');
					this.videos.push(this.background);
				} else if (this.backgroundImageDesktop) {
					this.background = new BackgroundImage(this.backgroundImageDesktop, 'desktop');
					this.videos.push(this.background);
				}


				this.hoverVideoElements = new Set([
					...container.querySelectorAll('[data-hover-video]'),
					...document.querySelectorAll('[data-buytickets-hover-video]'),
				]);
				this.hoverImageElements = new Set([
					...container.querySelectorAll('[data-hover-image]'),
					...document.querySelectorAll('[data-buytickets-hover-image]'),
				]);

				if (!this.background && !this.hoverVideoElements && !this.hoverImageElements) {
					resolve();
				}

				if (this.background) {
					this.background
						.init()
						.then(() => {
							resolve();
							if (this.hoverVideoElements) {
								this.hoverVideoElements.forEach((elm) => {
									if (!this.videoError) {
										const video = new BackgroundHoverVideo(elm);
										this.videos.push(video);
										video.init().catch(() => {
											this.videoError = true;
										});
									}
								});
							}
							if (this.hoverImageElements) {
								this.hoverImageElements.forEach((elm) => {
									const image = new BackgroundHoverImage(elm);
									this.videos.push(image);
								});
							}
						})
						.catch(() => {
							this.videoError = true;
							if (this.backgroundImageDesktop) {
								this.background = new BackgroundImage(this.backgroundImageDesktop, 'desktop');
								this.videos.push(this.background);
								this.background.init().then(() => {
									resolve();
								});
							} else {
								resolve();
							}
						});
				} else {
					resolve();
				}
			} else { // Mobile
				this.backgroundVideoMobile = container.querySelector('[data-background-video-mobile]');
				this.backgroundImageMobile = container.querySelector('[data-background-image-mobile]');
				if (this.backgroundVideoMobile) {
					this.background = new BackgroundVideo(this.backgroundVideoMobile, 'mobile');
					this.videos.push(this.background);
				} else if (this.backgroundImageMobile) {
					this.background = new BackgroundImage(this.backgroundImageMobile, 'mobile');
					this.videos.push(this.background);
				}
				if (this.background) {
					this.background
						.init()
						.then(() => {
							resolve();
						})
						.catch(() => {
							this.videoError = true;
							if (this.backgroundImageMobile) {
								this.background = new BackgroundImage(this.backgroundImageMobile, 'mobile');
								this.videos.push(this.background);
								this.background.init().then(() => {
									resolve();
								});
							} else {
								resolve();
							}
						});
				} else {
					resolve();
				}
			}

		});
	}

	destroyVideos() {
		this.background = null;
		this.backgroundVideoDesktop = null;
		this.backgroundImageDesktop = null;
		this.backgroundVideoMobile = null;
		this.backgroundImageMobile = null;
		if (this.videos) {
			this.videos.forEach((video) => {
				if (typeof video.destroy !== 'function') {
					return;
				}
				video.destroy();
			});
			this.videos = [];
		}
	}
}

const backgroundManager = new BackgroundManager();
export default backgroundManager;
